import {FailedRequestPayload, AxiosError} from '../types';
import {Action} from '../../actions';

export const ActionTypes = {
  FETCH_PPC_CONFIG_PENDING: 'ppc/fetch_PENDING',
  FETCH_PPC_CONFIG_FULFILLED: 'ppc/fetch_FULFILLED',
  FETCH_PPC_CONFIG_REJECTED: 'ppc/fetch_REJECTED'
};

export interface PpcConfigStatus {
  loadingPpcConfig: boolean;
  fetchedPpcConfig: boolean;
  ppcConfigError?: AxiosError | null;
}

export interface PpcConfigData {
  rateCode: string;
  ppcDate: Date;
}

export interface PpcConfigState extends PpcConfigStatus {
  [name: string]: any | null;
}

export interface FetchPpcConfigFulfilledPayload {
  [name: string]: string | null;
}

interface FetchPpcConfigFulfilledAction extends Action<FetchPpcConfigFulfilledPayload> {
  type: string;
  payload: PpcConfigState;
}

interface FetchPpcConfigRejectedAction extends Action<FailedRequestPayload> {
  type: string;
  payload: FailedRequestPayload;
}

export type PpcConfigActionTypes = FetchPpcConfigFulfilledAction | FetchPpcConfigRejectedAction;
